import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

/**
 * back and next link/button for advisor steps.
 */
@Component({
    selector: 'app-step-buttons',
    templateUrl: './step.buttons.component.html',
    standalone: false
})
export class StepButtonsComponent {
  /**
   * absolute router URL for the next step
   */
  @Input() nextLink: string = null;

  /**
   * If set, the next button will open an URL in a new window.
   */
  @Input() nextUrl: string = null;

  /**
   * absolute router URL for the back link
   */
  @Input() previousLink: string = null;

  /**
   * Textkey for the next link/button
   */
  @Input() nextText: string = 'step.button.next';

  /**
   * Textkey for the back link
   */
  @Input() previousText: string = null;

  /**
   * toggle for disabling the next button
   */
  @Input() nextDisabled: boolean = false;

  /**
   * toggle if the next button is a submit button. If set to false, it will be a link.
   */
  @Input() nextSubmit: boolean = true;

  /**
   * Extra class(es) for the next button
   */
  @Input() nextClass: string = '';

  /**
   * Extra class for the button wrapper to set background+teaser text if form is valid
   */
  @Input() backgroundClass: boolean = false;

  /**
   * Offset of the first columns on large screens, default is 1
   */
  @Input() largeOffset: number = 2;

  /**
   * Offset of the first columns on medium screens, default is 1
   */
  @Input() mediumOffset: number = 0;

  /**
   * Size of the large column with the right button
   */
  @Input() largeWidthRight: any = 5;

  /**
   * Size of the large column with the right button
   */
  @Input() mediumWidthRight: any = 5;

  /**
   * screen size for left alignment
   */
  @Input() leftAlignSize: string = 'large';

  /**
   * if set, there is an extra teasertext in front of the buttons shown
   */
  @Input() teaserText: string = null;

  /**
   * Eventemitter if the previous link is clicked
   */
  @Output() onPreviousClick: EventEmitter<void> = new EventEmitter<void>();

  /**
   * Eventemitter if the nextlink is clicked
   */
  @Output() onNextClick: EventEmitter<void> = new EventEmitter<void>();

  /**
   * constructor
   * @param sanitizer
   */
  constructor(private sanitizer: DomSanitizer){}

  /**
   * Eventhandler for the next click
   */
  nextClick(): void {
    this.onNextClick.emit();
  }

  /**
   * eventhandler for the previous click
   */
  previousClick(): void {
    this.onPreviousClick.emit();
  }

  /**
   * sanitize url for the next button if this lead to an external page
   * @param url
   */
  sanitizeUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
